import CanvasManager from './canvasManager';

export default CanvasManager;
